import React, { Suspense, type PropsWithChildren } from 'react';
import { SButton } from '@chargebee/sting-react';
import { AdminRouteSuspenseLoader } from '@bbkAdminComponents/loaders/admin-route-suspense-loader';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';

export class AuthenticatedAppBoundary extends React.Component<
  PropsWithChildren,
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    GlobalLogger.error('Failed to load the authenticated application', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          className="tw-flex tw-min-h-screen tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-p-6"
        >
          <p>We couldn’t open the application. Reload to try again.</p>
          <SButton onClick={() => window.location.reload()}>Reload</SButton>
        </div>
      );
    }

    return (
      <Suspense
        fallback={
          <div
            className="tw-h-screen"
            role="status"
            aria-label="Loading application"
          >
            <AdminRouteSuspenseLoader />
          </div>
        }
      >
        {this.props.children}
      </Suspense>
    );
  }
}
